export default __webpack_public_path__ + "static/media/top-ten-block-8.15a7f353.svg";